/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
    ScreenerGeneratedDocumentTypeToJSONTyped,
} from './ScreenerGeneratedDocumentType';

/**
 * 
 * @export
 * @interface UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner
 */
export interface UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    /**
     * 
     */
    type: ScreenerGeneratedDocumentType;
    /**
     * 
     */
    instance_id: string;
}



/**
 * Check if a given object implements the UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner interface.
 */
export function instanceOfUploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner(value: object): value is UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('instance_id' in value) || value['instance_id'] === undefined) return false;
    return true;
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSON(json: any): UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    return UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ScreenerGeneratedDocumentTypeFromJSON(json['type']),
        'instance_id': json['instance_id'],
    };
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSON(json: any): UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner {
    return UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInnerToJSONTyped(value?: UploadExternalEhrDocumentsRequestPushGeneratedDocumentInstancesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ScreenerGeneratedDocumentTypeToJSON(value['type']),
        'instance_id': value['instance_id'],
    };
}

